import clsx from 'clsx'
import map from 'lodash/map'
import React, { FC } from 'react'

import SvgAddToCart2 from '@Assets/SVG/AddToCart2'
import { BuyButtonV2 } from '@Components/BuyButton/v2'
import { ImageV4 } from '@Components/Image'
import { PromptDialog } from '@Domains/Cart/Components/Prompt/Dialog'
import { useAddToCart } from '@Domains/Cart/Hooks/useAddToCart'
import { Product, TacticRelativeDiscount } from '@Generated/graphql'
import { useTranslation } from '@Globals/Translations'

import styles from './ProductQuantityDiscount.module.scss'

export interface ProductQuantityDiscountProps {
  primaryProduct: Product
  tactic?: TacticRelativeDiscount
}

export const ProductQuantityDiscount: FC<ProductQuantityDiscountProps> = ({ primaryProduct, tactic }) => {
  const { t } = useTranslation()
  const [addToCart, { isLoading, prompts, reset, variables }] = useAddToCart()

  return (
    <div className={styles.productQuantityDiscount}>
      <div className={styles.title}>
        {t('common:BUNDLE_OFFER_PRODUCT_TAG')}
      </div>
      <div className={styles.quantityDiscountList}>
        {map(tactic?.relativeDiscounts, (relativeDiscount) => {
          const hasDiscount = !!relativeDiscount.price?.discount
          return (
            <div key={`ProductQuantityDiscount_${relativeDiscount.quantity}`} className={styles.quantityDiscountItem}>
              <div className={styles.imageWrapper}>
                <ImageV4 src={(primaryProduct as any)?.primaryAsset?.url || ''} width={42} />
              </div>
              <div className={styles.name}>
                {t('products:BUY_X_SAVE_X_LABEL', {
                  count: relativeDiscount.quantity,
                  percentage: relativeDiscount.percentage,
                })}
              </div>
              <div className={styles.priceWrapper}>
                <span className={clsx(styles.price, relativeDiscount.price?.discount && styles.discount)}>
                  {hasDiscount ? relativeDiscount.price?.discount?.format : relativeDiscount?.price?.format}
                </span>
                {hasDiscount && <span className={styles.beforePrice}>{relativeDiscount?.price?.format}</span>}
              </div>
              <BuyButtonV2 className={styles.buyButton} color="black" fillWidth={false} productID={primaryProduct.id} quantity={relativeDiscount.quantity}>
                <span>
                  <SvgAddToCart2 />
                </span>
              </BuyButtonV2>
            </div>
          )
        })}
      </div>

      {prompts && prompts.length !== 0 && (
        <PromptDialog
          isLoading={isLoading}
          onClose={reset}
          onSubmit={addToCart}
          prompts={prompts}
          promptsOrigin={variables}
        />
      )}
    </div>
  )
}

